import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import DocumentLoader from 'routes/Documents/containers/DocumentLoaderContainer';
import DocumentProvider from 'routes/Documents/containers/DocumentProvider';
import { actions } from 'store/newDocumentStore';

import Next from '../components/Next';

const NextContainer = ({ edit, create }) => (
  <DocumentLoader names={['next']}>
    <DocumentProvider>
      <Next onStartEdit={edit} onCreate={create} />
    </DocumentProvider>
  </DocumentLoader>
);

NextContainer.propTypes = {
  edit: PropTypes.func,
  create: PropTypes.func,
};

export default connect(null, { edit: actions.createCommit, create: actions.createDocumentAndCommit })(NextContainer);
